
import { RouteObject } from 'react-router-dom';
import { lazy } from 'react';

const HomePage = lazy(() => import('../pages/home/page'));
const AgendaPage = lazy(() => import('../pages/agenda/page'));
const ProgramasPage = lazy(() => import('../pages/programas/page'));
const LibroPage = lazy(() => import('../pages/libro/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />
  },
  {
    path: '/agenda',
    element: <AgendaPage />
  },
  {
    path: '/programas',
    element: <ProgramasPage />
  },
  {
    path: '/libros',
    element: <LibroPage />
  },
  {
    path: '*',
    element: <NotFoundPage />
  }
];

export default routes;
